export interface StudioPrompt {
    id: number;
    name: string;
    promptText: string;
    promptType: number;
    category: string;
    isActive: boolean;
    displayOrder: number;
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
}

export interface StudioPromptListResponse {
    items: StudioPrompt[];
    totalCount: number;
    totalPages: number;
}

export interface CreateStudioPromptRequest {
    name: string;
    promptText: string;
    promptType: number;
    category: string;
    isActive: boolean;
    displayOrder: number;
    createdBy?: string;
}

export interface UpdateStudioPromptRequest {
    id: number;
    name: string;
    promptText: string;
    promptType: number;
    category: string;
    isActive: boolean;
    displayOrder: number;
    updatedBy?: string;
}

export enum PromptType {
    AskilıSecim = 1,
    ModelliCekim = 2,
    HerIkisi = 3
}

